export default __webpack_public_path__ + "static/media/roadmap_moon.4e1bb965.png";